import { render, staticRenderFns } from "./SystemLogList.vue?vue&type=template&id=49801635&scoped=true&"
import script from "./SystemLogList.vue?vue&type=script&lang=js&"
export * from "./SystemLogList.vue?vue&type=script&lang=js&"
import style0 from "./SystemLogList.vue?vue&type=style&index=0&id=49801635&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49801635",
  null
  
)

export default component.exports